import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import './Rooms.css';

import roomCh2 from '../assets/imgs/rooms-ch2.png';

class Chapter2 extends Component {
    render() {
        return (
            <div className="Rooms" ref={(div) => (this.appContainer = div)}>
                <Header />
                <div className="Rooms-container">
                    <div className="Room-top"></div>
                    <div className="Room-mid">
                        <div className="Room-title">THE HIVE</div>
                        <div className="Room-img">
                            <img src={roomCh2} alt="" />
                        </div>
                        <div className="Room-description">
                            <div className="text">
                                Chapter 2 continues where Chapter 1 ended, surviving the vandal
                                attack on The Bunker. Now that you have escaped, you must make your
                                way to the UHC (United Human Compound). Your journey continues
                                crossing dangerous Vandal Territory. You and your group come across
                                a Vandal outpost "The Hive". You must search The Hive and find a
                                list of materials that you will need in order to survive the
                                conditions topside. Complete your mission and escape before
                                Lightcrawler discovers you.
                                <p>This game involves a live actor.</p>
                            </div>
                            <div className="table-container">
                                <div className="table-row">
                                    <div className="table-label">MISSION</div>
                                    <div className="table-text">Rescuing survivors.</div>
                                </div>
                                <div className="table-row">
                                    <div className="table-label">TIME</div>
                                    <div className="table-text">50 min</div>
                                </div>
                                <div className="table-row">
                                    <div className="table-label">PLAYERS</div>
                                    <div className="table-text">Min 2, Max 8</div>
                                </div>
                                <div className="table-row">
                                    <div className="table-label">DIFFICULTY</div>
                                    <div className="table-text">
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="note">
                                * If you desire to book a specific game that is not reflected on our
                                Ticket Schedule please contact us for further availability. <br />*
                                You can swap Chapters. If for a desired time slot you would prefer
                                to do another Chapter
                                <br /> that is originally offered on our Ticketing Site, please
                                contact us to swap for your preferred Chapter.
                            </div>
                        </div>
                    </div>
                    <div className="Room-bottom"></div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default Chapter2;
